import commonFunc from './common/_common';
import headerFunc from './common/_header';
import footerFunc from './common/_footer';
import faqToggle from './common/_faq-toggle';

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    faqToggle();
});
